import React from 'react';
import { useTheme } from 'styled-components';
import { regular } from '@fortawesome/fontawesome-svg-core/import.macro';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { Badge } from '@ui-library/badge';
import { SmallText } from '@ui-library/typography';

export const CurrentAccountBadge: React.FC = () => {
  const theme = useTheme();

  return (
    <Badge
      size="small"
      bgColor={theme.token['blue.2']}
      borderColor={theme.token.colorBorderSecondary}
      icon={
        <FontAwesomeIcon icon={regular('link-horizontal')} color={theme.token.colorPrimaryBase} />
      }
      label={
        <SmallText color={theme.token.colorPrimaryText} fontWeight={500}>
          Current
        </SmallText>
      }
    />
  );
};
